import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userInfo: {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
  },
  companyInfo: {},
  locations: [],
  currentLocationIndex: 0,
};

const registrationSlice = createSlice({
  name: "registration",
  initialState,
  reducers: {
    setUserInfo: (state, action) => {
      state.userInfo = { ...state.userInfo, ...action.payload };
    },
    setCompanyInfo: (state, action) => {
      state.companyInfo = { ...state.companyInfo, ...action.payload };
    },
    addLocation: (state, action) => {
      state.locations.push(action.payload);
    },
    updateLocation: (state, action) => {
      const { index, data } = action.payload;
      state.locations[index] = { ...state.locations[index], ...data };
    },
    deleteLocation: (state, action) => {
      state.locations.splice(action.payload, 1);
    },
    setCurrentLocationIndex: (state, action) => {
      state.currentLocationIndex = action.payload;
    },
    resetRegistration: (state) => {
      state.userInfo = initialState.userInfo;
      state.companyInfo = initialState.companyInfo;
      state.locations = [];
      state.currentLocationIndex = 0;
    },
  },
});

export const { 
  setUserInfo, 
  setCompanyInfo, 
  addLocation,
  updateLocation,
  deleteLocation,
  setCurrentLocationIndex,
  resetRegistration 
} = registrationSlice.actions;

export default registrationSlice.reducer;
